import * as styles from "./AutocompleteInput.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";

import { useAutocompleteContext } from "./Autocomplete.context";
import type { AutocompleteInputProps } from "./Autocomplete.types";
import { AutocompleteClear } from "./AutocompleteClear";
import { AutocompleteIcon } from "./AutocompleteIcon";

export function AutocompleteInput({
  className,
  clearable = true,
  iconPosition = "start",
  ...props
}: AutocompleteInputProps): JSX.Element {
  const { size } = useAutocompleteContext();

  const icon =
    iconPosition !== "none" ? (
      <AutocompleteIcon className={styles.icon} />
    ) : null;

  return (
    <BaseAutocomplete.InputGroup
      data-slot="autocomplete-input-group"
      className={styles.inputGroup({ size })}
    >
      {iconPosition === "start" ? icon : null}
      <BaseAutocomplete.Input
        data-slot="autocomplete-input"
        className={clsx(styles.input, className)}
        autoComplete="off"
        data-1p-ignore
        {...props}
      />
      {clearable ? <AutocompleteClear className={styles.clear} /> : null}
      {iconPosition === "end" ? icon : null}
    </BaseAutocomplete.InputGroup>
  );
}
